"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[261],{

/***/ 20261:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_native_web_dist_cjs_exports_StyleSheet__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(84099);
/* harmony import */ var react_native_web_dist_cjs_exports_StyleSheet__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(react_native_web_dist_cjs_exports_StyleSheet__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var react_native_web_dist_cjs_exports_View__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(79057);
/* harmony import */ var react_native_web_dist_cjs_exports_View__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(react_native_web_dist_cjs_exports_View__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(54176);
/* harmony import */ var _helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9465);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(85893);








var LocationBar = next_dynamic__WEBPACK_IMPORTED_MODULE_0___default()(function () {
  return __webpack_require__.e(/* import() */ 5686).then(__webpack_require__.bind(__webpack_require__, 95686));
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(95686)];
    }
  }
});
var MapContainer = next_dynamic__WEBPACK_IMPORTED_MODULE_0___default()(function () {
  return __webpack_require__.e(/* import() */ 4455).then(__webpack_require__.bind(__webpack_require__, 84455));
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(84455)];
    }
  }
});

var MapView = function MapView(props) {
  var category = props.category,
      address = props.address,
      street = props.street,
      postcode = props.postcode,
      location = props.location,
      accomodationUrl = props.accomodationUrl,
      transportUrl = props.transportUrl,
      mapLink = props.mapLink,
      venue = props.venue,
      city = props.city,
      country = props.country,
      isMobileVersion = props.isMobileVersion;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)((react_native_web_dist_cjs_exports_View__WEBPACK_IMPORTED_MODULE_5___default()), {
    style: [styles.container, props.style],
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)((react_native_web_dist_cjs_exports_View__WEBPACK_IMPORTED_MODULE_5___default()), {
      style: [styles.mapContainer, isMobileVersion ? {
        height: "auto"
      } : {}],
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(MapContainer, {
        location: location,
        address: address,
        street: street,
        venue: venue,
        city: city,
        mapLink: mapLink,
        country: country,
        accomodationUrl: accomodationUrl,
        transportUrl: transportUrl,
        style: {
          flex: 1
        },
        isMobileVersion: isMobileVersion
      })
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(LocationBar, {
      category: category,
      address: address,
      postcode: postcode,
      street: street,
      venue: venue,
      city: city,
      country: country,
      isMobileVersion: isMobileVersion
    })]
  });
};

var styles = react_native_web_dist_cjs_exports_StyleSheet__WEBPACK_IMPORTED_MODULE_6___default().create({
  container: {
    backgroundColor: (0,_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_3__/* .getClass */ .ll)("bg-gray1"),
    borderRadius: 20
  },
  mapContainer: {
    height: 600,
    alignSelf: "stretch",
    borderRadius: 20
  }
});
/* harmony default export */ __webpack_exports__["default"] = (MapView);

/***/ })

}]);